import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export default function ClientDetail({ viewing, onBack }) {
  return (
    <div data-testid="client-detail">
      <button onClick={onBack} className="text-sm text-[#DC2626] hover:underline mb-4">&larr; Retour aux clients</button>
      <div className="bg-white rounded-xl border p-6 mb-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-xl font-bold">{viewing.first_name} {viewing.last_name} {viewing.company_name}</h2>
            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded">{viewing.type}</span>
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-[#DC2626]">{viewing.total_invoiced?.toLocaleString('fr-FR')}€</p>
            <p className="text-xs text-gray-500">Total facturé</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          {viewing.phone && <p className="flex items-center gap-2"><Phone size={14} className="text-gray-400" />{viewing.phone}</p>}
          {viewing.email && <p className="flex items-center gap-2"><Mail size={14} className="text-gray-400" />{viewing.email}</p>}
          {viewing.address && <p className="flex items-center gap-2"><MapPin size={14} className="text-gray-400" />{viewing.address}, {viewing.postal_code} {viewing.city}</p>}
        </div>
        {viewing.notes && <p className="mt-3 text-sm text-gray-500 italic">{viewing.notes}</p>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border p-5">
          <h3 className="font-semibold mb-3">Véhicules ({viewing.vehicles?.length || 0})</h3>
          {viewing.vehicles?.map(v => <div key={v.id} className="py-2 border-b last:border-0 text-sm"><span className="font-medium">{v.brand} {v.model}</span> — {v.plate}</div>)}
        </div>
        <div className="bg-white rounded-xl border p-5">
          <h3 className="font-semibold mb-3">Devis ({viewing.quotes?.length || 0})</h3>
          {viewing.quotes?.map(q => <div key={q.id} className="flex justify-between py-2 border-b last:border-0 text-sm"><span>{q.number}</span><span className="font-medium">{q.total?.toLocaleString('fr-FR')}€</span></div>)}
        </div>
        <div className="bg-white rounded-xl border p-5">
          <h3 className="font-semibold mb-3">Factures ({viewing.invoices?.length || 0})</h3>
          {viewing.invoices?.map(inv => {
            const statusClass = inv.status === 'payee' ? 'text-green-600' : 'text-red-600';
            return (
              <div key={inv.id} className="flex justify-between py-2 border-b last:border-0 text-sm">
                <span>{inv.number}</span>
                <span className={`font-medium ${statusClass}`}>{inv.total?.toLocaleString('fr-FR')}€ ({inv.status})</span>
              </div>
            );
          })}
        </div>
        <div className="bg-white rounded-xl border p-5">
          <h3 className="font-semibold mb-3">Interventions ({viewing.interventions?.length || 0})</h3>
          {viewing.interventions?.map(it => {
            const statusClass = it.status === 'termine' ? 'text-green-600' : 'text-amber-600';
            return (
              <div key={it.id} className="py-2 border-b last:border-0 text-sm">
                <span className="font-medium">{it.description?.slice(0, 50)}</span> — <span className={statusClass}>{it.status}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
